import PhotosState from "./photos-state"

class PhotosBloc {
  constructor({ build, currentPhoto, userRepository, photosRepository }) {
    this._build = build
    this._userRepository = userRepository
    this._photosRepository = photosRepository

    this.state = PhotosState.initial().copyWith({
      backwardPhoto: photosRepository.loadFromStorage({
        photoId: currentPhoto.id,
        direction: "backward",
      }),
      currentPhoto,
      forwardPhoto: photosRepository.loadFromStorage({
        photoId: currentPhoto.id,
        direction: "forward",
      }),
    })
  }

  photosPreloaded() {
    this.update(
      this.state.copyWith({
        backwardPhoto: this._photosRepository.loadFromStorage({
          photoId: this.state.currentPhoto.id,
          direction: "backward",
        }),
        forwardPhoto: this._photosRepository.loadFromStorage({
          photoId: this.state.currentPhoto.id,
          direction: "forward",
        }),
      }),
    )
  }

  async photosLoadRequested(direction) {
    this.update(this.state.copyWith({ loading: true }))

    try {
      const newPhoto = await this._photosRepository.load({
        photoId: this.state.currentPhoto.id,
        direction,
      })

      if (newPhoto === null) {
        // No more photos in this direction
        this.update(
          this.state.copyWith({
            [direction === "backward" ? "backwardPhoto" : "forwardPhoto"]: null,
            loading: false,
          }),
        )
      } else {
        // Preload adjacent photos for smooth navigation
        await this._photosRepository.preload(newPhoto.id)

        // Update state with new photo but keep loading: true
        // The loader will be hidden when the image actually loads (via photosLoaded callback)
        this.update(
          this.state.copyWith({
            backwardPhoto: this._photosRepository.loadFromStorage({
              photoId: newPhoto.id,
              direction: "backward",
            }),
            currentPhoto: newPhoto,
            forwardPhoto: this._photosRepository.loadFromStorage({
              photoId: newPhoto.id,
              direction: "forward",
            }),
            loading: true, // Keep loading true until image loads
          }),
        )
      }
    } catch (error) {
      console.error(error)
      this.update(this.state.copyWith({ error: true, loading: false }))
    }
  }

  photosLoaded() {
    this.update(this.state.copyWith({ loading: false }))
  }

  photosButtonsVisibilityUpdated() {
    this.update(
      this.state.copyWith({
        backwardPhoto:
          this.state.backwardPhoto === null
            ? this._photosRepository.loadFromStorage({
                photoId: this.state.currentPhoto.id,
                direction: "backward",
              })
            : null,
        forwardPhoto:
          this.state.forwardPhoto === null
            ? this._photosRepository.loadFromStorage({
                photoId: this.state.currentPhoto.id,
                direction: "forward",
              })
            : null,
      }),
    )
  }

  // eslint-disable-next-line class-methods-use-this
  _replaceCommentInListById(commentList, newComment) {
    const index = commentList.findIndex(({ id }) => id === newComment.id)

    const newCommentList = []
    newCommentList.push(...commentList.slice(0, index))
    newCommentList.push(newComment)
    newCommentList.push(...commentList.slice(index + 1))

    return newCommentList
  }

  update(newState) {
    if (this.state.equals(newState)) return
    this._build(newState)
    this.state = newState
  }
}

export default PhotosBloc
